module.exports = __webpack_public_path__ + "static/media/p4.5925aa08.mp4";